import { genericFilterType } from "../reducers/genericFilterReducer";
import store from "../store";

export function getCurrentGlobalFilterObject(){
    const filterData:any = {};
    const genericFilterData = store?.getState()?.genericFilter;
    if(genericFilterData){
        Object.keys(genericFilterData).forEach(filterKey=>{
            if(genericFilterData[filterKey]){
                filterData[filterKey] = genericFilterData[filterKey] + "";
            }
        })
    }
    return filterData;
}


export function getCurrentGlobalFilter(){
    let filterData:string = "";
    const genericFilterData = store?.getState()?.genericFilter;
    if(genericFilterData){
        Object.keys(genericFilterData).forEach(filterKey=>{
            if(genericFilterData[filterKey]){
                filterData = filterData + "/" + filterKey + ":" + genericFilterData[filterKey];
            }
        })
    }
    return filterData;
}

export function updateGenericFilter(updatedFilter: genericFilterType){
    store.dispatch({
        type: "updateGenericFilter",
        payload: {
            ...updatedFilter
        }
    })
}

export function resetGenericFilter(newFilters: genericFilterType){
    store.dispatch({
        type: "resetGenericFilter",
        payload: {
            ...newFilters
        }
    })
}

export function clearGenericFilter(){
    store.dispatch({
        type: "clearGenericFilter",
        payload: {}
    })
}